import { render, staticRenderFns } from "./Datagraph5.vue?vue&type=template&id=31fa2710&scoped=true"
import script from "./Datagraph5.vue?vue&type=script&lang=js"
export * from "./Datagraph5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fa2710",
  null
  
)

export default component.exports